// extracted by mini-css-extract-plugin
module.exports = {"black-friday":"BlackFriday_black-friday__qCjOp"};